import React from 'react'
import Button from "@material-tailwind/react/Button";
import '../CSS/TestResult.css'
import { Link } from 'react-router-dom'
import { useStateValue} from '../StateProvider'

const TestResult = () => {

    const [{count, user}] = useStateValue();

    return (
        <div className="testResult">
            <div className="testResultSubDiv">
                <div className="resultScore">
                    <h1>{count}</h1>
                    <p>Moderate</p>
                </div>
                <div className="aboutResults">
                    <h2>Your Depression score is {count}/5</h2>
                    <p>Experiencing symptoms is common. By engaging in therapy will you learn strategies to 
                        reduce symptoms and manage everyday stressors.
                    </p>
                    <Link to={user ? '/AppointmentPage' : '/login_Signup'}>
                        <Button color="lightBlue"buttonType="filled" size="regular" iconOnly={false} ripple="light">
                            Match with a Counsellor
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default TestResult
